import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';
import { TextContentDataSchema, TextStyleOverrideSchema } from '@/components/canvas/elements/text/schema';

export const CircleElementSchema = BaseElementSchema.extend({
  type: z.literal('circle'),
  data: z.object({
    text: TextContentDataSchema.optional(),
    textStyle: TextStyleOverrideSchema.partial().optional(),
  }).default({}),
});
